import { h } from "preact";

import IconProps from "../IconProps";
import classname from "../../../foundation/utils/classname";

const DEFAULT_WIDTH = 14;
const DEFAULT_HEIGHT = 14;

function IconDotSpinner(props: Omit<IconProps, "height">) {
    const { class: cssClass, width, color } = props;
    const height = width! * DEFAULT_HEIGHT / DEFAULT_WIDTH;

    return (
        <svg class={classname("spinning", cssClass)} width={width} height={height} viewBox="0 0 24 24">
            <g fill={color} fill-rule="evenodd">
                <circle cx="12" cy="1.8" r="1.8"/>
                <circle cx="4.8" cy="4.82" r="1.8" fill-opacity=".44" transform="rotate(-45 4.796 4.82)"/>
                <circle cx="1.8" cy="12" r="1.8" fill-opacity=".52"/>
                <circle cx="4.82" cy="19.21" r="1.8" fill-opacity=".6" transform="rotate(-45 4.816 19.208)"/>
                <circle cx="12" cy="22.2" r="1.8" fill-opacity=".68"/>
                <circle cx="19.21" cy="19.18" r="1.8" fill-opacity=".76" transform="rotate(-45 19.206 19.18)"/>
                <circle cx="22.2" cy="12" r="1.8" fill-opacity=".84"/>
                <circle cx="19.18" cy="4.79" r="1.8" fill-opacity=".92" transform="rotate(-45 19.18 4.792)"/>
            </g>
        </svg>
    );
}

IconDotSpinner.defaultProps = {
    width: DEFAULT_WIDTH,
    color: "var(--cornflower-blue)"
};

export default IconDotSpinner;
